import { render, staticRenderFns } from "./UcretliSorguOnayDialog.vue?vue&type=template&id=d0f979a8"
import script from "./UcretliSorguOnayDialog.vue?vue&type=script&lang=ts"
export * from "./UcretliSorguOnayDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports